export default __webpack_public_path__ + "static/media/search-solid.3631c120.svg";